import { render, staticRenderFns } from "./kinds.vue?vue&type=template&id=09f0600c&scoped=true&"
import script from "./kinds.vue?vue&type=script&lang=js&"
export * from "./kinds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f0600c",
  null
  
)

export default component.exports